// Self-hosted Walnut Lakes photography (uploaded by owner)
const WL = {
  aerialNight: "https://customer-assets.emergentagent.com/job_scenic-retreat-2/artifacts/mp1n3xti_a_wide_aerial_overhead_night_landscape_scene_of_a.png",
  sunsetEntrance: "https://customer-assets.emergentagent.com/job_scenic-retreat-2/artifacts/xs3pgyxa_1426123.jpg",
  lilyLake: "https://customer-assets.emergentagent.com/job_scenic-retreat-2/artifacts/e1eoqir2_1426128.jpg",
  daisyLakePitches: "https://customer-assets.emergentagent.com/job_scenic-retreat-2/artifacts/xeyo5iqu_1111387.jpg",
  lakesideLodge: "https://customer-assets.emergentagent.com/job_scenic-retreat-2/artifacts/0nwfdsx7_1426126.jpg",
  eveningPitches: "https://customer-assets.emergentagent.com/job_scenic-retreat-2/artifacts/bhhknmxs_307994.jpg",
  goldenHourLake: "https://customer-assets.emergentagent.com/job_scenic-retreat-2/artifacts/oqbdg911_1111387.jpg",
};

// pitchup.com CDN fallback for remaining shots (uses CF image-resizing)
const PU_BASE = "https://www.pitchup.com/_cfi/cdn-cgi/image/format=auto,fit=cover,quality=85,w=1800,h=1200";
const pu = (path) => `${PU_BASE}${path}`;

export const IMAGES = {
  hero: WL.aerialNight,
  heroNight: WL.aerialNight,
  lakeView: WL.lilyLake,
  lodgeExterior: pu(
    "/images/3/image/upload/s--3UmhpMtB--/c_limit,h_2400,w_3200/e_improve,fl_progressive/q_auto/b_rgb:000,g_south_west,l_pitchup.com_wordmark_white_watermark,o_15/v1/walnut-lake-lodges-and-camping/1793615.jpg"
  ),
  lodgeCabin: WL.lakesideLodge,
  lodgeFromOutside: pu(
    "/images/5/image/upload/s--c61Er_R2--/c_limit,h_2400,w_3200/e_improve,fl_progressive/q_auto/b_rgb:000,g_south_west,l_pitchup.com_wordmark_white_watermark,o_15/v1/walnut-lake-lodges-and-camping/2028795.jpg"
  ),
  lodgeFromLake: WL.lakesideLodge,
  caravanPitches: WL.daisyLakePitches,
  walnutPitches: WL.eveningPitches,
  fishingLake: WL.lilyLake,
  daisyLake: WL.eveningPitches,
  niceFish: pu(
    "/images/2/image/upload/s--MR-R3MeZ--/c_limit,h_2400,w_3200/e_improve,fl_progressive/q_auto/b_rgb:000,g_south_west,l_pitchup.com_wordmark_white_watermark,o_15/v1/walnut-lake-lodges-and-camping/2046002.jpg"
  ),
  overlookingLakes: WL.eveningPitches,
  eveningViews: WL.sunsetEntrance,
  path: WL.goldenHourLake,
  dogWalk: pu(
    "/images/4/image/upload/s--gLqytB2U--/c_limit,h_2400,w_3200/e_improve,fl_progressive/q_auto/b_rgb:000,g_south_west,l_pitchup.com_wordmark_white_watermark,o_15/v1/walnut-lake-lodges-and-camping/2026173.jpg"
  ),
  facilities: pu(
    "/images/1/image/upload/s--_ttyowb3--/c_limit,h_2400,w_3200/e_improve,fl_progressive/q_auto/b_rgb:000,g_south_west,l_pitchup.com_wordmark_white_watermark,o_15/v1/walnut-lake-lodges-and-camping/1817714.jpg"
  ),
  toiletBlock: pu(
    "/images/1/image/upload/s--tmvKtBrK--/c_limit,h_2400,w_3200/e_improve,fl_progressive/q_auto/b_rgb:000,g_south_west,l_pitchup.com_wordmark_white_watermark,o_15/v1/walnut-lake-lodges-and-camping/2033482.jpg"
  ),
  springtime: WL.lilyLake,
  cabin: null,
  caravan: null,
  lake: null,
  trail: null,
};
IMAGES.cabin = IMAGES.lodgeCabin;
IMAGES.caravan = IMAGES.caravanPitches;
IMAGES.lake = IMAGES.fishingLake;
IMAGES.trail = IMAGES.path;

export const PARK = {
  name: "Walnut Lakes",
  fullName: "Walnut Lakes Holiday Park",
  logo: "https://customer-assets.emergentagent.com/job_scenic-retreat-2/artifacts/bw42ghvf_Walnut%20Lakes%20Branding%20Design.png",
  tagline: "An adults-only lakeside retreat in the Lincolnshire countryside",
  address: {
    lines: ["Walnut Lakes", "Main Road", "PE20 2LQ"],
  },
  phone: "07982 844201",
  phoneRaw: "07982844201",
  email: "justina@walnutlakes.co.uk",
  season: "Mid-March — end of November",
  award: "Practical Caravan Top 100 · Voted #1 in 2012",
  socials: {
    instagram: "https://www.instagram.com/walnut_lakes_camping/",
    facebook: "https://www.facebook.com/share/1DFJqcusWg/",
    pitchup: "https://www.pitchup.com/campsites/England/Central/Lincolnshire/Boston/walnut-lake-lodges-and-camping/",
    googleReviews: "https://www.google.com/search?q=walnut+lakes+reviews",
  },
};

export const LODGES = [
  {
    id: "lodge-heron",
    name: "Heron Lodge",
    price: 90,
    tag: "Cosy · lake view",
    image: IMAGES.lodgeFromOutside,
  },
  {
    id: "lodge-kingfisher",
    name: "Kingfisher Lodge",
    price: 100,
    tag: "Bright · waterside deck",
    image: IMAGES.lodgeExterior,
  },
  {
    id: "lodge-alpine",
    name: "Alpine Lodge",
    price: 120,
    tag: "Flagship · premium fit-out",
    image: IMAGES.lodgeCabin,
  },
];

export const NAV_LINKS = [
  { label: "The Park", href: "#about" },
  { label: "Lodges", href: "#stays" },
  { label: "Fishing", href: "#fishing" },
  { label: "Facilities", href: "#facilities" },
  { label: "Book", href: "#book" },
  { label: "Reviews", href: "#reviews" },
  { label: "Location", href: "#location" },
  { label: "Enquire", href: "#contact" },
];
